import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_RELEASE_SALARY);

const state = {
  data:[],
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  }
}

const actions = {
    async release({commit}, payload) {
        //console.log("[state/payroll/hold_salary_employees/create] Adding...", payload);
      try {
        // commit("setSaving", true);
        let res = await axios_instance.post('/', payload);
        // commit("set", fasetlse);
        //console.log("[state/payroll/hold_salary_employees/create] res: ", res);
        if(res.status == 200) {
          commit("set", payload.data);
        }
        return res;
      }catch(err){
        //console.log(err)
      }
    },
}  

export default {
    namespaced: true,
    state, mutations, actions
  }